import './App.css';
import { useState, useEffect, } from 'react';
import logo from './village.jpeg';
import React from 'react';

function TimestampToDateString(timestamp) {
    const date = new Date(timestamp * 1000);
    return date.toLocaleString();
}

function UserInfoDataTable({ data }) {
    const [expandedRows, setExpandedRows] = useState({});
    const [pushEndpointData, setPushEndpointData] = useState(data);

    // Sort data by guardian name
    const sortedData = [...pushEndpointData].sort((a, b) => {
        return a.Guardian.Name.localeCompare(b.Guardian.Name);
    });

    const toggleRow = (guardianId) => {
        setExpandedRows(prev => ({
            ...prev,
            [guardianId]: !prev[guardianId]
        }));
    };

    const handleDeleteGuardian = async (guardianId, guardianName) => {
        if (window.confirm(`Are you sure you want to delete guardian ${guardianName}?`)) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/adminApi?request=DeleteGuardian&guardianId=${guardianId}`, {
                    method: 'GET',
                    credentials: 'include'
                });

                if (response.status === 200) {
                    alert('Guardian deleted successfully');
                    // Remove the deleted guardian from the state
                    setPushEndpointData(prevData => prevData.filter(item => item.Guardian.GuardianId !== guardianId));
                } else {
                    const errorText = await response.text();
                    alert(`Failed to delete guardian: ${errorText}`);
                }
            } catch (error) {
                alert(`Error deleting guardian: ${error.message}`);
            }
        }
    };

    return (
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th>GuardianId</th>
                    <th>Name</th>
                    <th>PhoneNumber</th>
                    <th>Email</th>
                    <th>WasInvitedToHousehold</th>
                    <th>SignedTosTimestamp</th>
                    <th>SignedTosIP</th>
                </tr>
            </thead>
            <tbody>
                {sortedData.map((item, index) => (
                    <React.Fragment key={index}>
                        <tr>
                            <td>
                                <button
                                    onClick={() => toggleRow(item.Guardian.GuardianId)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: '1.2em'
                                    }}
                                >
                                    {expandedRows[item.Guardian.GuardianId] ? '▼' : '▶'}
                                </button>
                            </td>
                            <td>{item.Guardian.GuardianId}</td>
                            <td>{item.Guardian.Name}</td>
                            <td>{item.Guardian.PhoneNumber}</td>
                            <td>{item.Guardian.Email}</td>
                            <td>{item.Guardian.WasInvitedToHousehold.toString()}</td>
                            <td>{TimestampToDateString(item.Guardian.SignedTosTimestamp)}</td>
                            <td>{item.Guardian.SignedTosIP}</td>
                        </tr>
                        {expandedRows[item.Guardian.GuardianId] && (
                            <tr>
                                <td colSpan="8">
                                    <div style={{ padding: '10px', backgroundColor: '#f5f5f5', margin: '5px 0' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                            <h4 style={{ margin: 0 }}>Push Endpoints</h4>
                                            <button
                                                onClick={() => handleDeleteGuardian(item.Guardian.GuardianId, item.Guardian.Name)}
                                                style={{
                                                    backgroundColor: '#ff4444',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '5px 10px',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Delete Guardian
                                            </button>
                                        </div>
                                        <table style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>EndpointArn</th>
                                                    <th>Push Endpoint Enabled</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item.PushEndpoints && item.PushEndpoints.map((endpoint, idx) => (
                                                    <tr key={idx}>
                                                        <td>{endpoint.EndpointArn}</td>
                                                        <td style={{
                                                            color: endpoint.Enabled !== 'false' ? 'black' : 'red',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {endpoint.Enabled}
                                                        </td>
                                                    </tr>
                                                ))}
                                                {(!item.PushEndpoints || item.PushEndpoints.length === 0) && (
                                                    <tr>
                                                        <td colSpan="2" style={{ textAlign: 'center' }}>No push endpoints</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    );
}

function ActivityDataTable({ data }) {
    const [sortField, setSortField] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [activityData, setActivityData] = useState(data);

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDeleteActivity = async (activityId, householdId, description) => {
        if (window.confirm(`Are you sure you want to delete activity "${description}"?`)) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/adminApi?request=DeleteActivity&activityId=${activityId}&householdId=${householdId}`, {
                    method: 'GET',
                    credentials: 'include'
                });

                if (response.status === 200) {
                    alert('Activity deleted successfully');
                    // Remove the deleted activity from the state
                    setActivityData(prevData => prevData.filter(item => item.ActivityId !== activityId));
                } else {
                    const errorText = await response.text();
                    alert(`Failed to delete activity: ${errorText}`);
                }
            } catch (error) {
                alert(`Error deleting activity: ${error.message}`);
            }
        }
    };

    const sortedData = [...activityData].sort((a, b) => {
        if (!sortField) return 0;

        let comparison = 0;
        if (sortField === 'StartTimeUTCSeconds' || sortField === 'EndTimeUTCSeconds') {
            comparison = a[sortField] - b[sortField];
        } else {
            comparison = String(a[sortField] || '').localeCompare(String(b[sortField] || ''));
        }

        return sortDirection === 'asc' ? comparison : -comparison;
    });

    const getSortIcon = (field) => {
        if (sortField !== field) return '↕';
        return sortDirection === 'asc' ? '↑' : '↓';
    };

    return (
        <table>
            <thead>
                <tr>
                    <th>Activity ID</th>
                    <th>Child ID(s)</th>
                    <th>Description</th>
                    <th onClick={() => handleSort('StartTimeUTCSeconds')} style={{ cursor: 'pointer' }}>
                        Start Time {getSortIcon('StartTimeUTCSeconds')}
                    </th>
                    <th onClick={() => handleSort('EndTimeUTCSeconds')} style={{ cursor: 'pointer' }}>
                        End Time {getSortIcon('EndTimeUTCSeconds')}
                    </th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Last Updated By</th>
                    <th>Location</th>
                    <th>Household Name</th>
                    <th>Household ID</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {sortedData.map((activity, index) => (
                    <tr key={index}>
                        <td>{activity.ActivityId}</td>
                        <td>{activity.ChildrenIds && activity.ChildrenIds.join(', ')}</td>
                        <td>{activity.Description}</td>
                        <td>{TimestampToDateString(activity.StartTimeUTCSeconds)}</td>
                        <td>{TimestampToDateString(activity.EndTimeUTCSeconds)}</td>
                        <td>{activity.Status || ''}</td>
                        <td>{activity.CreatedBy || ''}</td>
                        <td>{activity.LastUpdatedBy || ''}</td>
                        <td>{activity.Location}</td>
                        <td>{activity.HouseholdName}</td>
                        <td>{activity.HouseholdId}</td>
                        <td>
                            <button
                                onClick={() => handleDeleteActivity(activity.ActivityId, activity.HouseholdId, activity.Description)}
                                style={{
                                    backgroundColor: '#ff4444',
                                    color: 'white',
                                    border: 'none',
                                    padding: '5px 10px',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

function HouseholdDataTable({ data }) {
    const [expandedRows, setExpandedRows] = useState({});
    const [householdData, setHouseholdData] = useState(data);

    const toggleRow = (householdId) => {
        setExpandedRows(prev => ({
            ...prev,
            [householdId]: !prev[householdId]
        }));
    };

    const handleDeleteHousehold = async (householdId, householdName) => {
        if (window.confirm(`Are you sure you want to delete household ${householdName}?`)) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/adminApi?request=DeleteHousehold&householdId=${householdId}`, {
                    method: 'GET',
                    credentials: 'include'
                });
                if (response.status === 200) {
                    alert('Household deleted successfully');
                    setHouseholdData(prevData => prevData.filter(item => item.householdId !== householdId));
                } else {
                    const errorText = await response.text();
                    alert(`Failed to delete household: ${errorText}`);
                }
            } catch (error) {
                alert(`Error deleting household: ${error.message}`);
            }
        }
    };

    return (
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th>Household ID</th>
                    <th>Name</th>
                    <th>Guardians Count</th>
                    <th>Children Count</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {householdData.map((household, index) => (
                    <React.Fragment key={index}>
                        <tr>
                            <td>
                                <button
                                    onClick={() => toggleRow(household.householdId)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: '1.2em'
                                    }}
                                >
                                    {expandedRows[household.householdId] ? '▼' : '▶'}
                                </button>
                            </td>
                            <td>{household.householdId}</td>
                            <td>{household.name}</td>
                            <td>{household.guardians ? household.guardians.length : 0}</td>
                            <td>{household.children ? household.children.length : 0}</td>
                            <td>
                                <button
                                    onClick={() => handleDeleteHousehold(household.householdId, household.name)}
                                    style={{
                                        backgroundColor: '#ff4444',
                                        color: 'white',
                                        border: 'none',
                                        padding: '5px 10px',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Delete Household
                                </button>
                            </td>
                        </tr>
                        {expandedRows[household.householdId] && (
                            <tr>
                                <td colSpan="6">
                                    <div style={{ padding: '10px', backgroundColor: '#f5f5f5', margin: '5px 0' }}>
                                        {household.guardians && household.guardians.length > 0 && (
                                            <div style={{ marginBottom: '20px' }}>
                                                <h4 style={{ margin: '0 0 10px 0' }}>Guardians</h4>
                                                <table style={{ width: '100%' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Email</th>
                                                            <th>Phone Number</th>
                                                            <th>Signed TOS</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {household.guardians.map((guardian, idx) => (
                                                            <tr key={idx}>
                                                                <td>{guardian.Name}</td>
                                                                <td>{guardian.Email}</td>
                                                                <td>{guardian.PhoneNumber}</td>
                                                                <td>{TimestampToDateString(guardian.SignedTosTimestamp)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        {household.children && household.children.length > 0 && (
                                            <div>
                                                <h4 style={{ margin: '0 0 10px 0' }}>Children</h4>
                                                <table style={{ width: '100%' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Favorite Foods</th>
                                                            <th>Disliked Foods</th>
                                                            <th>Bedtime Routine</th>
                                                            <th>Restrictions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {household.children.map((child, idx) => (
                                                            <tr key={idx}>
                                                                <td>{child.Name}</td>
                                                                <td>{child.FavoriteFoods.join(', ') || 'None'}</td>
                                                                <td>{child.DislikedFoods.join(', ') || 'None'}</td>
                                                                <td>{child.BedtimeRoutine.join(', ') || 'None'}</td>
                                                                <td>{child.Restrictions.join(', ') || 'None'}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        {(!household.guardians || household.guardians.length === 0) &&
                                            (!household.children || household.children.length === 0) && (
                                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                                    No guardians or children in this household
                                                </div>
                                            )}
                                    </div>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    );
}

const AdminPage = () => {
    const [pushEndpointData, setPushEndpointData] = useState('');
    const [activityData, setActivityData] = useState('');
    const [householdData, setHouseholdData] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [activeTab, setActiveTab] = useState('guardians');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        const checkAdminStatus = async () => {
            try {
                const loginResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/login${code ? `?code=${code}` : ""}`, {
                    method: 'POST',
                    credentials: 'include'
                });

                if (loginResponse.status === 200) {
                    console.log('loginResponse', loginResponse);
                    setIsLoggedIn(true);
                    const isAdminResult = loginResponse.headers.get('X-Koy-Admin') === 'true';
                    setIsAdmin(isAdminResult);
                    if (isAdminResult) {
                        // Fetch guardians data
                        const pushEndpointResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/adminApi?request=GetGuardians`, {
                            method: 'GET',
                            credentials: 'include'
                        });
                        const pushEndpointJson = await pushEndpointResponse.json();
                        setPushEndpointData(pushEndpointJson);

                        // Fetch activities data
                        const activitiesResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/adminApi?request=GetActivities`, {
                            method: 'GET',
                            credentials: 'include'
                        });
                        const activitiesJson = await activitiesResponse.json();
                        setActivityData(activitiesJson);

                        // Fetch households data
                        const householdsResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/adminApi?request=GetHouseholds`, {
                            method: 'GET',
                            credentials: 'include'
                        });
                        const householdsJson = await householdsResponse.json();
                        setHouseholdData(householdsJson);
                    }
                } else {
                    setIsLoggedIn(false);
                    setPushEndpointData(' ');
                    setActivityData(' ');
                    setHouseholdData(' ');
                }
            } catch (error) {
                setIsLoggedIn(false);
                console.error('Error checking login status:', error);
            }
        };

        checkAdminStatus();
    }, []);

    const renderTabContent = () => {
        switch (activeTab) {
            case 'guardians':
                return pushEndpointData ? <UserInfoDataTable data={pushEndpointData} /> : <p>Loading...</p>;
            case 'activities':
                return activityData ? <ActivityDataTable data={activityData} /> : <p>Loading...</p>;
            case 'households':
                return householdData ? <HouseholdDataTable data={householdData} /> : <p>Loading...</p>;
            default:
                return null;
        }
    };

    return (
        <div className="App">
            <div className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
            </div>
            <div className="App-body App-body-center">
                <div>
                    <p>Admin</p>
                    <div className="tabs">
                        <button
                            className={`tab-button ${activeTab === 'guardians' ? 'active' : ''}`}
                            onClick={() => setActiveTab('guardians')}
                        >
                            Guardians
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'activities' ? 'active' : ''}`}
                            onClick={() => setActiveTab('activities')}
                        >
                            Activities
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'households' ? 'active' : ''}`}
                            onClick={() => setActiveTab('households')}
                        >
                            Households
                        </button>
                    </div>
                    <div className="tab-content">
                        {renderTabContent()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminPage;